import { Suspense } from "react";
import AuthSkeleton from "@/components/auth-skeleton";
import OtherOtpVerifyPage from "@/app/auth/other-otp/other-otp";

export default function AuthOtherOtpPage() {
  return (
    <Suspense fallback={<AuthSkeleton />}>
      <OtherOtpVerifyPage />
    </Suspense>
  )
}
